import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getData, deleteData, postData, putData, DeleteData } from "../../../utility/Utility";
import Swal from "sweetalert2";
import CustomLoader from "../../../Components/CustomLoader/CustomLoader";

function RewardList() {
  const navigate = useNavigate();
  const [rewards, setRewards] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const rowsPerPage = 10;

  const fetRewards = async (page = 1, search = "") => {
    setLoading(true);
    try {
      const response = await postData("api/reward-config/list", {
        search: search,
        page: page,
        limit: rowsPerPage,
        totalPages:rowsPerPage
      });

      if (response?.success) {
        setRewards(response.data);
        setTotalPages(response.pagination.totalPages);
        setTotalItems(response.pagination.totalItems);
      } else {
        toast.error(response?.message || "Failed to fetch categories");
      }
    } catch (error) {
      console.log("error",error)
      // toast.error("Error fetching categories");
      console.error("Fetch categories error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetRewards(currentPage + 1, searchTerm);
  }, [currentPage,searchTerm]);

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setCurrentPage(0);
    fetRewards(1, searchTerm);
  };

  const handleReset = () => {
    setSearchTerm("");
    setCurrentPage(0);
    fetRewards(1);
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        const response = await deleteData(`api/reward-config/delete`, {
          rewardConfigId:id,
        });
        if (response.success) {
          toast.success("Reward  deleted successfully");
          fetRewards(currentPage + 1, searchTerm);
        } else {
          toast.error(response.message || "Failed to delete reward");
        }
      } catch (error) {
        toast.error("Error deleting category");
        console.error("Delete category error:", error);
      }
    }
  };

  const handleStatusChange = async (reward) => {
    const newStatus = reward.status === "active" ? "inactive" : "active";

    const result = await Swal.fire({
      title: `Are you sure you want to ${newStatus === "active" ? "activate" : "deactivate"} this Reward?`,
      text: `The Reward will be ${newStatus === "active" ? "activated" : "deactivated"}.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${newStatus === "active" ? "activate" : "deactivate"} it!`,
    });

    if (result.isConfirmed) {
      try {
        const response = await putData(`api/reward-config/update`, {
          isActive: true,
          rewardConfigId: reward?._id,
        });

        if (response.success) {
          toast.success(`Category ${newStatus === "active" ? "activated" : "deactivated"} successfully`);
          fetRewards(currentPage + 1, searchTerm);
        } else {
          toast.error(response.message || `Failed to ${newStatus === "active" ? "activate" : "deactivate"} category`);
        }
      } catch (error) {
        toast.error(`Error ${newStatus === "active" ? "activating" : "deactivating"} category`);
        console.error("Status change error:", error);
      }
    }
  };

  return (
    <div className="content-page">
      <ToastContainer position="top-right" autoClose={3000} />
      <CustomLoader loading={loading} />
      <div className="content">
        <div className="container-fluid">
          <div className="py-3 d-flex align-items-sm-center flex-sm-row flex-column justify-content-between">
            <div className="flex-grow-1">
              <h4 className="fs-18 fw-semibold m-0">Reward Management</h4>
              <p className="fw-semibold my-2">Reward List</p>
            </div>
            <div>
              <button
                className="btn btn-primary"
                onClick={() => navigate("/add-reward")}
                disabled={loading}
              >
                <i className="mdi mdi-plus-square me-1"></i>
                Add Reward
              </button>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row g-3 align-items-center">
                      <div className="col-md-12 col-lg-4">
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control ps-4"
                            placeholder="Search Rewards..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                          <span className="input-group-text">
                            <i className="mdi mdi-magnify"></i>
                          </span>
                        </div>
                      </div>

                      <div className="col-md-12 col-lg-3 d-flex gap-2">
                        <button
                          type="submit"
                          className="btn btn-primary"
                          disabled={loading}
                        >
                          Search
                        </button>

                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={handleReset}
                          disabled={loading}
                        >
                          Reset
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-2">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  {loading ? (
                    <div className="text-center py-5">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <th>S.No</th>
                             <th>Category Image</th>
                            <th>Category Name</th>
                            <th>Percentage (%)</th>
                            <th>Redeem Day</th>
                          
                            <th>Status</th>
                         
                            <th width="150px">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {rewards.length > 0 ? (
                            rewards.map((reward, index) => (
                              <tr key={reward._id}>
                                <td>{currentPage * rowsPerPage + index + 1}</td>
                                <td> <img src={reward?.category_id?.image} style={{ width: 50, height: 50 }} /></td>
                                <td>{reward?.category_id?.title}</td>
                                <td>{reward.percentage}</td>
                                 <td>{reward.redeemAfterDays}</td>
                              
                                <td>

                                  {reward.isActive ? <span className="text-primary">
                                    Active
                                  </span> :<span className="text-danger"> InActive</span>}
                                  {/* <span
                                    className={`badge text-capitalize bg-${reward.isActive === 'active' ? 'success' : 'danger'}`}
                                  >
                                    {reward.isActive}
                                  </span> */}
                                </td>
                           
                                <td>
                                  <div className="d-flex gap-2">
                                    <button
                                      className="btn btn-sm btn-outline-primary"
                                      onClick={() =>
                                        navigate(`/add-reward`, {
                                          state: { rewardData: reward },
                                        })
                                      }
                                    >
                                      <i className="mdi mdi-pencil"></i>
                                    </button>
                                    <button
                                      className={`btn btn-sm btn-outline-${reward?.status === 'active' ? 'warning' : 'success'}`}
                                      onClick={() => handleStatusChange(reward)}
                                      title={reward.status === 'active' ? 'Deactivate' : 'Activate'}
                                    >
                                      <i className={`mdi mdi-${reward.status === 'active' ? 'close' : 'check'}`}></i>
                                    </button>
                                    <button
                                      className="btn btn-sm btn-outline-danger"
                                      onClick={() => handleDelete(reward?._id)}
                                    >
                                      <i className="mdi mdi-delete"></i>
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            !loading && (
                              <tr>
                                <td colSpan="7" className="text-center py-4">
                                  No categories found
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>

                      {totalPages > 1 && (
                        <ReactPaginate
                          previousLabel={<i className="mdi mdi-chevron-left"></i>}
                          nextLabel={<i className="mdi mdi-chevron-right"></i>}
                          breakLabel="..."
                          breakClassName="page-item"
                          breakLinkClassName="page-link"
                          pageCount={totalPages}
                          marginPagesDisplayed={2}
                          pageRangeDisplayed={5}
                          onPageChange={handlePageChange}
                          containerClassName="pagination pagination-rounded justify-content-end mt-3"
                          pageClassName="page-item"
                          pageLinkClassName="page-link"
                          previousClassName="page-item"
                          previousLinkClassName="page-link"
                          nextClassName="page-item"
                          nextLinkClassName="page-link"
                          activeClassName="active"
                          forcePage={currentPage}
                        />
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RewardList;